import { makeStyles } from '@mui/styles';

// colors
import { colors } from '../../../../../colors';

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    border: `1px solid ${colors.neutral100}`,
    borderRadius: '8px !important',
    boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.04)',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: 4,
    minWidth: 680,
  },
  header: {
    padding: 24,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontWeight: 600,
    fontSize: 18,
    lineHeight: '24px',
    color: colors.neutral900,
    backgroundColor: 'white',
    borderTopRightRadius: 8,
    borderTopLeftRadius: 8,
  },
  headerSubTitle: {
    color: colors.neutral600,
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
  },
  body: {
    borderTop: `1px solid ${colors.neutral100}`,
    borderBottom: `1px solid ${colors.neutral100}`,
    padding: 24,
  },
  medicationBody: {
    backgroundColor: colors.neutral50,
    padding: 24,
    display: 'flex',
    gap: 12,
    overflowY: 'auto',
  },
  card: {
    background: colors.white,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    borderRadius: 8,
    padding: '16px 16px 16px 24px',
    gap: 8,
    border: `1px solid ${colors.neutral200}`,
    boxShadow: '0px 2px 6px 0px #0000000A',
  },
  sessionCard: {
    background: colors.white,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    borderRadius: 8,
    padding: '29px 24px 29px 24px',
    border: `1px solid ${colors.neutral200}`,
    gap: 24,
    boxShadow: '0px 2px 6px 0px #0000000A',
  },
  cardTitle: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: '24px',
  },
  cardSubTitle: {
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
  },
  footer: {
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'white',
    borderBottomRightRadius: 8,
    borderBottomLeftRadius: 8,
    gap: '4px',
  },
  cardItemText: {
    maxWidth: '90%',
  },
  footerText: {
    textAlign: 'center',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
    color: colors.neutral900,
  },
  footerBtn: {
    textTransform: 'none !important',
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '20px',
    color: colors.primary500,
    maxHeight: '20px',
  },
  editBtn: {
    textTransform: 'none !important',
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '20px !important',
    width: '100% !important',
    color: `${colors.primary500} !important`,
    background: 'transparent !important',
    display: 'flex',
    gap: 8,
    '& svg': {
      width: 18,
      height: 18,
    },
  },
  title: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: '24px',
    color: colors.neutral900,
  },
  cardText: {
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '24px',
    color: colors.neutral700,
  },
  dataItem: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
  },
  dataValue: {
    fontWeight: 700,
    fontSize: '12px',
    lineHeight: '16px',
    padding: '4px 8px',
    borderRadius: '4px',
    height: '24px',
  },
  visitFrequency: {
    width: 22,
    height: 22,
  },
  cardItem: {
    paddingBottom: '16px',
    paddingTop: '16px',
    // borderTop: `1px solid ${colors.neutral100}`,
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '24px',
  },
  cardBorderBottom: {
    borderBottom: `1px solid ${colors.neutral100}`,
  },
  cardQuoteBorderBottom: {
    borderBottom: `1px solid ${colors.neutral100}`,
    paddingBottom: '16px',
  },
  cardItemCheckList: {
    display: 'flex',
    flexDirection: 'row',
    gap: 24,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  cardQuote: {
    color: colors.neutral700,
    background: colors.neutral50,
    padding: 16,
    display: 'flex',
    flexDirection: 'row',
    gap: 12,
    borderRadius: 6,
  },
  checkIcon: {
    width: 16.67,
    height: 16.67,
    '& path': {
      fill: colors.success500,
    },
  },
  crossIcon: {
    width: 19,
    height: 19,
    '& path': {
      fill: colors.destructive500,
    },
  },
  warningBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
    padding: '16px',
    borderRadius: '8px',
    backgroundColor: colors.white,
    border: `1px solid ${colors.indigo300}`,
    maxHeight: '72px',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 600,
    color: colors.neutral700,
  },
  iconSize: {
    width: '20px',
    height: '20px',
  },
  bold: {
    fontWeight: 700,
  },
  warningBoxContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  backBtn: {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 600,
    color: colors.primary600,
    maxHeight: '20px',
    maxWidth: '120px',
    padding: '0px !important',
  },
});
